import { Stack, Snackbar as MuiSnackBar } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import React from "react";
import { useStore } from "../../store/store";


const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const SnackBar = () => {
    const {
        notifications: { notification, setNotification },
    } = useStore();

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }

        setNotification({ isOpen: false });
    };

    if (!notification) return null;

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <MuiSnackBar
                open={notification.isOpen}
                autoHideDuration={notification?.autoHideDuration ?? 12000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleClose} severity={notification.severity} sx={{ width: "100%" }}>
                    {typeof notification.message === 'string' 
                        ? (() => {
                            const messageLines = notification.message.split('\n');
                            return messageLines.map((line: string, index: number) => (
                                <React.Fragment key={index}>
                                    {line}
                                    {index < messageLines.length - 1 && <br />}
                                </React.Fragment>
                            ));
                        })()
                        : notification.message
                    }
                </Alert>
            </MuiSnackBar>
        </Stack>
    );
};
